exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".section-banner {\n  background-position: center center !important;\n  height: 400px;\n  background-color: #000 !important;\n}\n", ""]);

